<template>
  <div class="center">
    <div class="loading">
      <p v-if="status">{{ status }}</p>
      <p>
        <img id="snail" src="@/assets/loading.gif" alt="" />
        <!-- img id="snake" src="@/assets/loading_.gif" alt="" / -->
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.center {
  text-align: center;

  img {
    max-width: 50%;
  }
}

.loading {
  display: inline-block;
  position: relative;
  font-size: 2rem;
}

#snail {
  width: 333px;
}

#snake {
  display: inline-block;
  position: absolute;
  top: 0px;
  left: 44px;
  width: 523px;
}
</style>

<script>
export default {
  props: {
    status: {
      type: String,
      default: null
    }
  }
}
</script>
